// © Microsoft Corporation. All rights reserved.

import { ComponentConnector } from "../../Social.props";
import React from "react";
import { SocialClassNameContract } from "../../Social.classnames";
import { SocialLocalizedStrings } from "../../Social.localizedStrings";
import { TelemetryObjectBase } from "@msnews/telemetry-contracts";
import { exclamation_round } from "../../utils/icons";
import openGuidelinePage from "../../utils/openGuidelinePage";
import { renderHybrid } from "../../Social.telemetry";

export interface DisabledMessageProps {
    managedClasses?: SocialClassNameContract;
    message: string;
    showGuidelines?: boolean;
    hideIcon?: boolean;
    t?: SocialLocalizedStrings;
    mainTelemetryObject?: TelemetryObjectBase;
    componentConnector?: ComponentConnector;
    theme?: string;
    market?: string;
}

export default class DisabledMessage extends React.Component<DisabledMessageProps> {
    containerRef: HTMLDivElement;

    constructor(props) {
        super(props);
    }

    render() {
        const {t, message, managedClasses, mainTelemetryObject, showGuidelines, hideIcon, componentConnector, theme, market} = this.props;

        return (
            <div
                className={`${ showGuidelines ? "cwt-link" : ""} ${managedClasses.disabledMessageContainer} no-select`}
                role={`${ showGuidelines ? "link" : ""}`}
                title={showGuidelines ? `${t.DisabledMessagesGuidelines}` : `${t.DisabledMessagesInfo}`}
                {...(showGuidelines ? openGuidelinePage(componentConnector, theme, market, "_blank") : {})}
                {...renderHybrid(mainTelemetryObject, true)}
            >
                <i className="cwt-icon cwt-disabled-message">
                    { message }
                    { !hideIcon ? exclamation_round : ""}
                </i>
            </div>
        );
    }
}